var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ab-customer-list"},[_c('ab-block',{attrs:{"title":"已服务客户","subTitle":"10w+客户的信任与选择"}},[_c('div',{staticClass:"logo-list warp"},[_c('ab-customers')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }